import {add_todo, delete_todo, update_todo} from "../../api/td_todo.api"
import {update_ps_order} from "../../api/orders.api";

const getDefaultState = () => {
    return {
        td_todos: []
    }
}

// initial state
const state = getDefaultState()


const mutations = {
    set_td_todos(state, td_todos) {
        state.td_todos = td_todos
    },


    update_todo(state, todo) {
        state.td_todos = [
            ...state.td_todos.filter(element => element.id !== todo.id),
            todo
        ]
    },

    add_todo(state, todo) {
        state.td_todos = [todo,...state.td_todos]
    },

    delete_todo(state, todo) {
        state.td_todos = state.td_todos.filter(function( obj )
        {
            return obj.id !== todo.id;
        })
    },
    resetState (state) {
        Object.assign(state, getDefaultState())
    }


}

const actions = {
    todo_add({state, commit}, todo) {

        // On met à jour la base
        return new Promise((resolve, reject) =>
            add_todo(todo)
                .then((response) => {
                    if (response.status == '200') {

                        // On commit dans le state
                        /*response.data.todos.forEach(item => {
                            item.comments = []
                            commit('add_todo', item)
                        })*/

                        this._vm.$message({
                            message: 'Création todo OK',
                            type: 'success',center: true
                        });
                    }
                })
                .catch(error => {
                    this._vm.$message({
                        message: 'Création todo KO',
                        type: 'error',center: true
                    });
                })
        )
    },

    todo_update({state, commit}, todo) {

        // On met à jour la base
        return new Promise((resolve, reject) =>
            update_todo(todo)
                .then((response) => {
                    if (response.status == '200') {
                        resolve(response)
                    }
                })
                .catch(error => {
                    reject(error)
                })
        )
    },
    todo_delete({state, commit}, todo) {

        // On met à jour la base
        return new Promise((resolve, reject) =>
            delete_todo(todo)
                .then((response) => {
                    if (response.status == '200') {

                        // On commit dans le state
                        /*commit('delete_todo', todo)*/

                        //commit('update_order_detail_warehouse',order_detail);
                        this._vm.$message({
                            message: 'Suppression todo OK',
                            type: 'success',center: true
                        });
                    }
                })
                .catch(error => {
                    this._vm.$message({
                        message: 'Suppression todo KO',
                        type: 'error',
                        center: true
                    });
                })
        )
    }
}

const getters = {
    orderDetailTodos: (state => (id_order_detail, id_user = null) =>
    {
        return state.td_todos.filter(item => item.id_order_detail === id_order_detail && (id_user === null ^ (item.id_user === id_user && item.active == 1))).sort(function(a, b) {
            return a.id - b.id;
        });

    }),

    user_td_todos:(state => (id_user) => {
        return state.td_todos.filter(item => item.id_user === id_user).sort(function(a, b) {
            return a.id - b.id;
        });
    })
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}